"use client";
import { transitions } from "../transitions.mjs";
//#region packages/@mantine/core/src/components/Transition/get-transition-styles/get-transition-styles.ts
const transitionStatuses = {
	entering: "in",
	entered: "in",
	exiting: "out",
	exited: "out",
	"pre-exiting": "out",
	"pre-entering": "out"
};
function getTransitionStyles({ transition, state, duration, timingFunction }) {
	const shared = {
		WebkitBackfaceVisibility: "hidden",
		transitionDuration: `${duration}ms`,
		transitionTimingFunction: timingFunction
	};
	if (typeof transition === "string") {
		if (!(transition in transitions)) return {};
		return {
			transitionProperty: transitions[transition].transitionProperty,
			...shared,
			...transitions[transition].common,
			...transitions[transition][transitionStatuses[state]]
		};
	}
	return {
		transitionProperty: transition.transitionProperty,
		...shared,
		...transition.common,
		...transition[transitionStatuses[state]]
	};
}
//#endregion
export { getTransitionStyles };

//# sourceMappingURL=get-transition-styles.mjs.map